export const prepareRestart = async (route) => {
    for (let index = 0; index < route.steps.length; index++) {
        const step = route.steps[index];
        const stepHasFailed = step.execution?.status === 'FAILED';
        if (stepHasFailed) {
            deleteFailedProcesses(step);
            deleteTransactionData(step);
        }
    }
};
const deleteFailedProcesses = (step) => {
    if (step.execution) {
        step.execution.process = step.execution.process.filter((process) => process.status === 'DONE');
    }
};
const deleteTransactionData = (step) => {
    step.transactionRequest = undefined;
};
//# sourceMappingURL=prepareRestart.js.map